export const FETCH_AGENT_STATUS = "FETCH_AGENT_STATUS";
export const FETCH_AGENT_STATUS_SUCCESS = "FETCH_AGENT_STATUS_SUCCESS";

export const FETCH_AGENT_ON_BREAK_DETAILS = "FETCH_AGENT_ON_BREAK_DETAILS";
export const FETCH_AGENT_ON_BREAK_DETAILS_SUCCESS =
  "FETCH_AGENT_ON_BREAK_DETAILS_SUCCESS";

export const FETCH_TOTAL_AGENT_LIST = "FETCH_TOTAL_AGENT_LIST";
export const FETCH_TOTAL_AGENT_LIST_SUCCESS = "FETCH_TOTAL_AGENT_LIST_SUCCESS";

export const CALL_AGENT_STATUS_AGGREGATE = "CALL_AGENT_STATUS_AGGREGATE";

export const fetchAgentStatusData = (payload) => ({
  type: FETCH_AGENT_STATUS,
  payload,
});
export const fetchAgentStatusDataSuccess = (payload) => ({
  type: FETCH_AGENT_STATUS_SUCCESS,
  payload,
});

export const fetchAgentBreakDetails = (payload) => ({
  type: FETCH_AGENT_ON_BREAK_DETAILS,
  payload,
});
export const fetchAgentBreakDetailsSuccess = (payload) => ({
  type: FETCH_AGENT_ON_BREAK_DETAILS_SUCCESS,
  payload,
});

export const aggregateCallMonitoringAgentStatus = (payload) => ({
  type: CALL_AGENT_STATUS_AGGREGATE,
  payload,
});

export const fetchTotalAgentsList = (payload) => ({
  type: FETCH_TOTAL_AGENT_LIST,
  payload,
});

export const fetchTotalAgentsListSuccess = (payload) => ({
  type: FETCH_TOTAL_AGENT_LIST_SUCCESS,
  payload,
});
